<ng-container *ngIf="!isConnected; else removeConnected">
    <div class="db-domain-primary {{ssl}}">
        <h3 [innerHTML]="'text_confirmMakePrimary.header' | dbText" class="mb10"></h3>
        <p [innerHTML]="message"></p>
        <div class="db-domain-primary-ssl mt30" *ngIf="!ssl && !disableMakePrimary">
            <label class="db-fc-checkbox" *ngIf="enableSSL">
                <input type="checkbox" [formControl]="enableSSL" [checked]="enableSSL.value">
                <span class="ds-check-icon-wrap"><i class="db-icon db-icon-ds-checkmark"></i></span>
            </label>
          <span class="db-ssl-text">{{ 'text_enableFreeSSL' | dbText:{companyName: companyName} }}</span>
        </div>
        <div class="db-domain-primary-buttons mt30">
            <button class="{{cancelButtonClass}}" (click)="activeModal.close()"><span>{{cancelButtonText}}</span></button>
            <button class="ds-btn-black" *ngIf="!disableMakePrimary" (click)="confirm()"><span>{{'text_confirmMakePrimary.button' | dbText}}</span></button>
        </div>
    </div>
</ng-container>


<ng-template #removeConnected>
</ng-template>

